import { environment } from './environment';

export const projectImageUrl = (hackathonId: number, projectId: number) =>
  `${environment.apiUrl}/api/hackathon/${hackathonId}/project/${projectId}/heroimage`;
